export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: this.$t('Solicitud'),
                    type: 'custom-html',
                    key: 'evaluator_type',
                    modifier: (value) => {
                        return value.value;
                    }
                    
                },
                {
                    title: this.$t('Nombre'),
                    type: 'custom-html',
                    key: 'evaluator',
                    isVisible: true,
                    modifier: (value) => {
                        return value.full_name;
                    }
                },
                {
                    title: this.$t('Estado'),
                    type: 'custom-html',
                    key: 'is_confirmed',
                    modifier: (value) => {
                        // return value;
                        return `<span class="badge badge-sm badge-pill badge-success">Aceptado</span>`;
                    }                  
                },  
            ],
        }
    },
}